"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4463],{

/***/ 11485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ BaseButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/baseui/esm/button/button.js + 3 modules
var button_button = __webpack_require__(53674);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 3 modules
var polished_esm = __webpack_require__(43281);
// EXTERNAL MODULE: ./components/hooks/use-overrides.ts
var use_overrides = __webpack_require__(58817);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(32317);
;// CONCATENATED MODULE: ./components/base-button/use-button-style.tsx



var useButtonStyle = function($type, $size) {
    var backgroundColor = {
        primary: colors/* colors.blue400 */.O.blue400,
        secondary: colors/* colors.blue50 */.O.blue50,
        tertiary: colors/* colors.white */.O.white,
        danger: colors/* colors.red400 */.O.red400,
        warning: colors/* colors.red50 */.O.red50,
        text: colors/* colors.white */.O.white
    }[$type];
    var hoverBackgroundColor = {
        primary: colors/* colors.blue500 */.O.blue500,
        secondary: colors/* colors.blue100 */.O.blue100,
        tertiary: colors/* colors.blue50 */.O.blue50,
        danger: colors/* colors.red500 */.O.red500,
        warning: colors/* colors.red100 */.O.red100,
        text: colors/* colors.blue50 */.O.blue50
    }[$type];
    var color = {
        primary: colors/* colors.white */.O.white,
        secondary: colors/* colors.blue400 */.O.blue400,
        tertiary: colors/* colors.blue400 */.O.blue400,
        danger: colors/* colors.white */.O.white,
        warning: colors/* colors.red400 */.O.red400,
        text: colors/* colors.gray700 */.O.gray700
    }[$type];
    var hoverColor = {
        primary: colors/* colors.white */.O.white,
        secondary: colors/* colors.blue400 */.O.blue400,
        tertiary: colors/* colors.blue400 */.O.blue400,
        danger: colors/* colors.white */.O.white,
        warning: colors/* colors.red400 */.O.red400,
        text: colors/* colors.gray700 */.O.gray700
    }[$type];
    var disabledBackgroundColor = {
        primary: colors/* colors.gray300 */.O.gray300,
        secondary: colors/* colors.gray100 */.O.gray100,
        tertiary: colors/* colors.white */.O.white,
        danger: colors/* colors.gray300 */.O.gray300,
        warning: colors/* colors.gray100 */.O.gray100,
        text: colors/* colors.gray100 */.O.gray100
    }[$type];
    var disabledColor = {
        primary: colors/* colors.white */.O.white,
        secondary: colors/* colors.gray300 */.O.gray300,
        tertiary: colors/* colors.gray300 */.O.gray300,
        danger: colors/* colors.white */.O.white,
        warning: colors/* colors.gray300 */.O.gray300,
        text: colors/* colors.gray300 */.O.gray300
    }[$type];
    var border = {
        primary: "transparent",
        secondary: "transparent",
        tertiary: colors/* colors.blue100 */.O.blue100,
        danger: "transparent",
        warning: "transparent",
        text: "transparent"
    }[$type];
    var hoverBorder = {
        primary: "transparent",
        secondary: "transparent",
        tertiary: colors/* colors.blue50 */.O.blue50,
        danger: "transparent",
        warning: "transparent",
        text: colors/* colors.gray50 */.O.gray50
    }[$type];
    var size = {
        l: (0,_object_spread/* default */.Z)({
            fontSize: "18px",
            lineHeight: "22px"
        }, (0,polished_esm/* padding */.o3)("11px", "19px")),
        m: (0,_object_spread/* default */.Z)({
            fontSize: "16px",
            lineHeight: "20px"
        }, (0,polished_esm/* padding */.o3)("7px", "19px")),
        s: (0,_object_spread/* default */.Z)({
            fontSize: "14px",
            lineHeight: "18px"
        }, (0,polished_esm/* padding */.o3)("4px", "19px"))
    }[$size];
    return {
        backgroundColor: backgroundColor,
        hoverBackgroundColor: hoverBackgroundColor,
        color: color,
        hoverColor: hoverColor,
        disabledBackgroundColor: disabledBackgroundColor,
        disabledColor: disabledColor,
        border: border,
        hoverBorder: hoverBorder,
        size: size
    };
};

// EXTERNAL MODULE: ./components/icon/icon.tsx + 175 modules
var icon = __webpack_require__(32079);
// EXTERNAL MODULE: ./components/hooks/use-space.ts
var use_space = __webpack_require__(16333);
;// CONCATENATED MODULE: ./components/base-button/base-button.tsx











var BaseButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, overrides = _param.overrides, fluid = _param.fluid, leading = _param.leading, trailing = _param.trailing, _$size = _param.$size, $size = _$size === void 0 ? "l" : _$size, _$type = _param.$type, $type = _$type === void 0 ? "primary" : _$type, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "overrides",
        "fluid",
        "leading",
        "trailing",
        "$size",
        "$type",
        "spaceTop",
        "spaceBottom",
        "width"
    ]);
    var _$ref = useButtonStyle($type, $size), backgroundColor = _$ref.backgroundColor, hoverBackgroundColor = _$ref.hoverBackgroundColor, color = _$ref.color, hoverColor = _$ref.hoverColor, disabledBackgroundColor = _$ref.disabledBackgroundColor, disabledColor = _$ref.disabledColor, border = _$ref.border, hoverBorder = _$ref.hoverBorder, size = _$ref.size;
    var _$ref1 = (0,use_space/* useSpace */.$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = _$ref1.marginTop, marginBottom = _$ref1.marginBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        overrides: (0,use_overrides/* useOverrides */.Q)({
            BaseButton: {
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, size, marginTop, marginBottom), {
                    color: color,
                    backgroundColor: backgroundColor,
                    width: width ? "".concat(width, "px") : fluid ? "100%" : "auto",
                    boxSizing: "border-box",
                    fontWeight: 500,
                    wordBreak: "keep-all",
                    whiteSpace: "pre",
                    position: "relative"
                }), (0,polished_esm/* borderRadius */.E0)("left", "48px"), (0,polished_esm/* borderRadius */.E0)("right", "48px"), (0,polished_esm/* borderWidth */.J4)("1px"), (0,polished_esm/* borderStyle */.$u)("solid"), (0,polished_esm/* borderColor */.tv)(border)), {
                    ":active": {
                        backgroundColor: backgroundColor
                    },
                    ":hover": (0,_object_spread/* default */.Z)({
                        color: hoverColor,
                        backgroundColor: hoverBackgroundColor
                    }, (0,polished_esm/* borderColor */.tv)(hoverBorder)),
                    ":disabled": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        color: disabledColor,
                        backgroundColor: disabledBackgroundColor
                    }, (0,polished_esm/* borderColor */.tv)("transparent")), {
                        ":hover": (0,_object_spread/* default */.Z)({
                            color: disabledColor,
                            backgroundColor: disabledBackgroundColor
                        }, (0,polished_esm/* borderColor */.tv)("transparent"))
                    })
                })
            },
            StartEnhancer: {
                style: {
                    marginRight: "4px"
                }
            },
            EndEnhancer: {
                style: {
                    marginLeft: "4px"
                }
            },
            LoadingSpinnerContainer: {
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,polished_esm/* margin */.e6)("0px")), {
                    height: size.lineHeight,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                })
            }
        }, overrides),
        startEnhancer: leading && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
            type: leading,
            size: $size === "l" ? 16 : 12,
            color: props.disabled ? disabledColor : color
        }),
        endEnhancer: trailing && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* Icon */.J, {
            type: trailing,
            size: $size === "l" ? 16 : 12,
            color: props.disabled ? disabledColor : color
        })
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 26022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoBoxWithIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45500);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54511);
/* harmony import */ var _base_block__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94306);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32079);










var InfoBoxWithIcon = function(param) {
    var children = param.children, icon = param.icon;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_block__WEBPACK_IMPORTED_MODULE_3__/* .BaseBlock */ .v, {
        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            width: "100%"
        }, (0,polished__WEBPACK_IMPORTED_MODULE_6__/* .padding */ .o3)("20px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .borderRadius */ .E0)(16), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_7__/* .border */ .Cg)(_styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray200 */ .O.gray200)), {
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box"
        })),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .J, {
                type: icon,
                size: 32,
                color: _styles_colors__WEBPACK_IMPORTED_MODULE_8__/* .colors.gray700 */ .O.gray700
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_block__WEBPACK_IMPORTED_MODULE_3__/* .BaseBlock */ .v, {
                marginTop: "12px",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 99407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ BasicLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/styletron-react/dist-browser-esm/index.js
var dist_browser_esm = __webpack_require__(54511);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/constants.ts
var constants = __webpack_require__(45875);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/colors.ts
var styles_colors = __webpack_require__(32317);
// EXTERNAL MODULE: ./components/base-button/base-button.tsx + 1 modules
var base_button = __webpack_require__(11485);
// EXTERNAL MODULE: ./modules/users/hooks/use-me.tsx
var use_me = __webpack_require__(17243);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid.js + 1 modules
var flex_grid = __webpack_require__(46322);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid-item.js
var flex_grid_item = __webpack_require__(11524);
// EXTERNAL MODULE: ./components/logo/logo.tsx + 1 modules
var logo = __webpack_require__(49965);
// EXTERNAL MODULE: ./components/header/header-menu.tsx
var header_menu = __webpack_require__(97006);
// EXTERNAL MODULE: ./styles/box-shadow.ts
var box_shadow = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/base-grid/base-grid.tsx
var base_grid = __webpack_require__(83825);
// EXTERNAL MODULE: ./components/base-cell/base-cell.tsx
var base_cell = __webpack_require__(84525);
// EXTERNAL MODULE: ./styles/z-indexes.ts
var z_indexes = __webpack_require__(9227);
// EXTERNAL MODULE: ./lib/routes.ts
var routes = __webpack_require__(78954);
// EXTERNAL MODULE: ./lib/hooks/use-scroll-point.tsx
var use_scroll_point = __webpack_require__(51774);
// EXTERNAL MODULE: ./components/base-block/base-block.tsx
var base_block = __webpack_require__(94306);
// EXTERNAL MODULE: ./components/header/drawer.tsx
var drawer = __webpack_require__(95587);
// EXTERNAL MODULE: ./lib/graphql/documents.generated.ts
var documents_generated = __webpack_require__(60369);
;// CONCATENATED MODULE: ./components/header/header.tsx
























var Header = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,src_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref[0];
    var ref1 = (0,use_me/* useMe */.P)(), me = ref1.me, loading = ref1.loading;
    var isLoggedIn = Boolean(me);
    var isPoint = (0,use_scroll_point/* useScrollPoint */.A)().isPoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: css((0,_object_spread/* default */.Z)({
            position: "fixed",
            top: 0,
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: styles_colors/* colors.white */.O.white,
            zIndex: z_indexes/* zIndexes.header */.U.header
        }, isPoint && (0,box_shadow/* boxShadow */.W)("borderBottom"))),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_grid/* BaseGrid */.w, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_cell/* BaseCell */.q, {
                span: [
                    4,
                    8,
                    12
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex_grid/* default */.Z, {
                    className: css({
                        height: constants/* HEADER_HEIGHT */.M + "px",
                        display: "flex",
                        alignItems: "center"
                    }),
                    gridColumnGap: "32px",
                    flexGridColumnCount: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                            className: css({
                                flex: "1 1 0"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                size: "s",
                                active: true
                            })
                        }, "logo"),
                        !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                                    display: [
                                        "none",
                                        "none",
                                        "block",
                                        "block"
                                    ],
                                    className: css({
                                        flex: "1 1 auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                                    className: css({
                                        flex: "1 1 0",
                                        display: "flex",
                                        justifyContent: "flex-end"
                                    }),
                                    children: !loading && isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* BaseDrawer */.L, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu/* HeaderMenu */.y, {
                                                menus: (0,_to_consumable_array/* default */.Z)(me && (me === null || me === void 0 ? void 0 : me.role) !== documents_generated/* UserRole.Patient */.i4.Patient && [
                                                    {
                                                        name: "해석 참여하기",
                                                        icon: "ChevronRight",
                                                        href: routes/* Routes.DOCTOR_HOME */.Z.DOCTOR_HOME,
                                                        onClick: undefined,
                                                        color: undefined
                                                    }, 
                                                ] || []).concat([
                                                    {
                                                        name: "설정",
                                                        icon: undefined,
                                                        href: routes/* Routes.SETTINGS_ACCOUNT */.Z.SETTINGS_ACCOUNT,
                                                        onClick: undefined,
                                                        color: undefined
                                                    }, 
                                                ])
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                                        flexbox: true,
                                        columnGap: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                                    $type: "secondary",
                                                    $size: "m",
                                                    children: "로그인"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                                    $size: "m",
                                                    children: "회원가입"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var NavItem = function(param) {
    var href = param.href, label = param.label, selected = param.selected;
    var ref = _sliced_to_array(useStyletron(), 1), css = ref[0];
    return /*#__PURE__*/ _jsx(Link, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ _jsx(LabelS, {
            as: "a",
            weight: 500,
            color: selected ? colors.black : colors.gray500,
            children: label
        })
    });
};

// EXTERNAL MODULE: ./components/footer/footer.tsx + 2 modules
var footer = __webpack_require__(5516);
;// CONCATENATED MODULE: ./components/layouts/basic-layout.tsx








var BasicLayout = function(param) {
    var children = param.children, overrides = param.overrides, helmetTitle = param.helmetTitle;
    var ref;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            helmetTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: helmetTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: css({
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                    overflow: "hidden"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: css(merge_default()({
                            flex: "1 1 auto",
                            overflowY: "hidden",
                            overflowX: "hidden",
                            position: "relative",
                            marginTop: constants/* HEADER_HEIGHT */.M + "px"
                        }, (overrides === null || overrides === void 0 ? void 0 : (ref = overrides.main) === null || ref === void 0 ? void 0 : ref.style) || {})),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 29387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ NoticeLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _basic_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99407);
/* harmony import */ var _components_base_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83825);
/* harmony import */ var _components_base_cell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84525);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32317);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53321);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67408);
/* harmony import */ var _components_info_box_with_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26022);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94306);
/* harmony import */ var _components_footer_menus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1749);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32079);











var NoticeLayout = function(param) {
    var children = param.children, helmetTitle = param.helmetTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_layout__WEBPACK_IMPORTED_MODULE_2__/* .BasicLayout */ .i, {
        helmetTitle: helmetTitle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_grid__WEBPACK_IMPORTED_MODULE_3__/* .BaseGrid */ .w, {
            spaceTop: [
                24,
                48,
                72
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_cell__WEBPACK_IMPORTED_MODULE_4__/* .BaseCell */ .q, {
                    span: [
                        4,
                        6,
                        8
                    ],
                    skip: [
                        0,
                        1,
                        0
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_5__/* .HeadingM */ .aw, {
                            children: "공지사항"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_6__/* .BaseBlock */ .v, {
                            marginTop: "40px",
                            marginBottom: "40px",
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_cell__WEBPACK_IMPORTED_MODULE_4__/* .BaseCell */ .q, {
                    span: [
                        4,
                        3,
                        3
                    ],
                    skip: [
                        0,
                        1,
                        1
                    ],
                    spaceTop: [
                        72,
                        72,
                        72
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_info_box_with_icon__WEBPACK_IMPORTED_MODULE_7__/* .InfoBoxWithIcon */ .R, {
                        icon: "AlertOn",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_8__/* .LabelM */ .i_, {
                                children: "온톨의 SNS에서 새로운 소식을 받아보세요."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_6__/* .BaseBlock */ .v, {
                                flexbox: true,
                                columnGap: "12px",
                                marginTop: "24px",
                                children: _components_footer_menus__WEBPACK_IMPORTED_MODULE_9__/* .socialMedia.map */ .L.map(function(param) {
                                    var label = param.label, href = param.href, colorIcon = param.colorIcon;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_10__/* .Icon */ .J, {
                                                type: colorIcon,
                                                size: 32,
                                                color: _styles_colors__WEBPACK_IMPORTED_MODULE_11__/* .colors.gray400 */ .O.gray400
                                            })
                                        })
                                    }, label);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 32985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o_": function() { return /* binding */ remainingTime; },
/* harmony export */   "r8": function() { return /* binding */ dateFormatCurring; },
/* harmony export */   "vc": function() { return /* binding */ dateFormat; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77349);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32912);
/* harmony import */ var date_fns_locale_ko__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3006);
/* harmony import */ var _interval_to_duration_time__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76476);




/**
 *
 * @param date
 * @param dateFormat default: 'yyyy-MM-dd HH:mm'
 * @returns
 */ var dateFormat = function(date) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "yyyy.MM.dd HH:mm";
    if (!date) return undefined;
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), dateFormat, {
        locale: date_fns_locale_ko__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    });
};
var remainingTime = function(date) {
    var amount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!date) return undefined;
    var time = (0,_interval_to_duration_time__WEBPACK_IMPORTED_MODULE_2__/* .intervalTimeFromNow */ .s)({
        start: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(new Date(date), amount)
    });
    return time;
};
var dateFormatCurring = function(formatText) {
    return function(date) {
        return dateFormat(date, formatText);
    };
};


/***/ }),

/***/ 76476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ intervalTimeFromNow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94306);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32317);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61436);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98236);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var _date_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32985);





var intervalTimeFromNow = function(param) {
    var start = param.start, _format = param.format, format = _format === void 0 ? "HH:mm:ss" : _format;
    if (!(0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(start)) return;
    var now = new Date();
    var times = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        start: start,
        end: now
    });
    var years = times.years, days = times.days, hours = times.hours, minutes = times.minutes, months = times.months, seconds = times.seconds;
    var time = (0,_date_format__WEBPACK_IMPORTED_MODULE_3__/* .dateFormat */ .vc)(new Date(years, months, days, hours, minutes, seconds), format);
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(now, start) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_5__/* .BaseBlock */ .v, {
        as: "span",
        color: _styles_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.gray400 */ .O.gray400,
        children: "00:00:00"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_5__/* .BaseBlock */ .v, {
        as: "span",
        color: hours < 4 ? _styles_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.red400 */ .O.red400 : _styles_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.gray700 */ .O.gray700,
        children: time
    });
};


/***/ })

}]);